import type { IApplicationByAliasResponse } from "@/services/apiHandlers/applications/types";

export interface ISinglePageAppProps {
  appAlias: string;
  application: IApplicationByAliasResponse;
}

export interface IReview {
  reviewTitle: string;
  review: string;
  rate: number;
}

export enum AddOrEditEnum {
  add = "add",
  edit = "edit",
}
